const TAG_COLOR_PALETTES = [
  {
    solid: 'bg-rose-100 text-rose-700 border-rose-200 dark:bg-rose-900/30 dark:text-rose-300 dark:border-rose-800',
    subtle: 'bg-rose-50 text-rose-700 border-rose-200 hover:bg-rose-100 dark:bg-rose-900/20 dark:text-rose-300 dark:border-rose-800',
    selected: 'bg-rose-100 text-rose-800 border-rose-300 ring-1 ring-rose-300 dark:bg-rose-900/40 dark:text-rose-200 dark:border-rose-700',
  },
  {
    solid: 'bg-amber-100 text-amber-700 border-amber-200 dark:bg-amber-900/30 dark:text-amber-300 dark:border-amber-800',
    subtle: 'bg-amber-50 text-amber-700 border-amber-200 hover:bg-amber-100 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800',
    selected: 'bg-amber-100 text-amber-800 border-amber-300 ring-1 ring-amber-300 dark:bg-amber-900/40 dark:text-amber-200 dark:border-amber-700',
  },
  {
    solid: 'bg-lime-100 text-lime-700 border-lime-200 dark:bg-lime-900/30 dark:text-lime-300 dark:border-lime-800',
    subtle: 'bg-lime-50 text-lime-700 border-lime-200 hover:bg-lime-100 dark:bg-lime-900/20 dark:text-lime-300 dark:border-lime-800',
    selected: 'bg-lime-100 text-lime-800 border-lime-300 ring-1 ring-lime-300 dark:bg-lime-900/40 dark:text-lime-200 dark:border-lime-700',
  },
  {
    solid: 'bg-emerald-100 text-emerald-700 border-emerald-200 dark:bg-emerald-900/30 dark:text-emerald-300 dark:border-emerald-800',
    subtle: 'bg-emerald-50 text-emerald-700 border-emerald-200 hover:bg-emerald-100 dark:bg-emerald-900/20 dark:text-emerald-300 dark:border-emerald-800',
    selected: 'bg-emerald-100 text-emerald-800 border-emerald-300 ring-1 ring-emerald-300 dark:bg-emerald-900/40 dark:text-emerald-200 dark:border-emerald-700',
  },
  {
    solid: 'bg-cyan-100 text-cyan-700 border-cyan-200 dark:bg-cyan-900/30 dark:text-cyan-300 dark:border-cyan-800',
    subtle: 'bg-cyan-50 text-cyan-700 border-cyan-200 hover:bg-cyan-100 dark:bg-cyan-900/20 dark:text-cyan-300 dark:border-cyan-800',
    selected: 'bg-cyan-100 text-cyan-800 border-cyan-300 ring-1 ring-cyan-300 dark:bg-cyan-900/40 dark:text-cyan-200 dark:border-cyan-700',
  },
  {
    solid: 'bg-sky-100 text-sky-700 border-sky-200 dark:bg-sky-900/30 dark:text-sky-300 dark:border-sky-800',
    subtle: 'bg-sky-50 text-sky-700 border-sky-200 hover:bg-sky-100 dark:bg-sky-900/20 dark:text-sky-300 dark:border-sky-800',
    selected: 'bg-sky-100 text-sky-800 border-sky-300 ring-1 ring-sky-300 dark:bg-sky-900/40 dark:text-sky-200 dark:border-sky-700',
  },
  {
    solid: 'bg-indigo-100 text-indigo-700 border-indigo-200 dark:bg-indigo-900/30 dark:text-indigo-300 dark:border-indigo-800',
    subtle: 'bg-indigo-50 text-indigo-700 border-indigo-200 hover:bg-indigo-100 dark:bg-indigo-900/20 dark:text-indigo-300 dark:border-indigo-800',
    selected: 'bg-indigo-100 text-indigo-800 border-indigo-300 ring-1 ring-indigo-300 dark:bg-indigo-900/40 dark:text-indigo-200 dark:border-indigo-700',
  },
  {
    solid: 'bg-violet-100 text-violet-700 border-violet-200 dark:bg-violet-900/30 dark:text-violet-300 dark:border-violet-800',
    subtle: 'bg-violet-50 text-violet-700 border-violet-200 hover:bg-violet-100 dark:bg-violet-900/20 dark:text-violet-300 dark:border-violet-800',
    selected: 'bg-violet-100 text-violet-800 border-violet-300 ring-1 ring-violet-300 dark:bg-violet-900/40 dark:text-violet-200 dark:border-violet-700',
  },
  {
    solid: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200 dark:bg-fuchsia-900/30 dark:text-fuchsia-300 dark:border-fuchsia-800',
    subtle: 'bg-fuchsia-50 text-fuchsia-700 border-fuchsia-200 hover:bg-fuchsia-100 dark:bg-fuchsia-900/20 dark:text-fuchsia-300 dark:border-fuchsia-800',
    selected: 'bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300 ring-1 ring-fuchsia-300 dark:bg-fuchsia-900/40 dark:text-fuchsia-200 dark:border-fuchsia-700',
  },
  {
    solid: 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700',
    subtle: 'bg-slate-50 text-slate-700 border-slate-200 hover:bg-slate-100 dark:bg-slate-800/60 dark:text-slate-300 dark:border-slate-700',
    selected: 'bg-slate-100 text-slate-800 border-slate-300 ring-1 ring-slate-300 dark:bg-slate-700 dark:text-slate-200 dark:border-slate-600',
  },
] as const;

function hashString(input: string): number {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function getTagColorClasses(tagIdOrName: string) {
  const index = hashString(tagIdOrName) % TAG_COLOR_PALETTES.length;
  return TAG_COLOR_PALETTES[index];
}
